import { createVuetify } from 'vuetify'
import 'vuetify/styles'

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { nl } from 'vuetify/locale'; // Import Dutch locale

const colors = {
  // Green; 1st color
  'primary-darken-4': '#597413', // #597413
  'primary-darken-3': '#688716', // #688716
  'primary-darken-2': '#769a19', // #769a19
  'primary-darken-1': '#85ae1c', // #85ae1c
  primary: '#94C11F', // #94C11F
  'primary-lighten-1': '#9fc735', // #9fc735
  'primary-lighten-2': '#a9cd4c', // #a9cd4c
  'primary-lighten-3': '#b4d462', // #b4d462
  'primary-lighten-4': '#bfda79', // #bfda79
  // Orange; 2nd color
  'secondary-darken-4': '#8c3707', // #8c3707
  'secondary-darken-3': '#a44008', // #a44008
  'secondary-darken-2': '#bb4909', // #bb4909
  'secondary-darken-1': '#d3520a', // #d3520a
  secondary: '#EA5B0B', // #EA5B0B
  'secondary-lighten-1': '#ec6b23', // #ec6b23
  'secondary-lighten-2': '#ee7c3c', // #ee7c3c
  'secondary-lighten-3': '#f08c54', // #f08c54
  'secondary-lighten-4': '#f29d6d', // #f29d6d
  // Yellow; 3rd color
  'ternary-darken-4': '#998000', // #998000
  'ternary-darken-3': '#b39500', // #b39500
  'ternary-darken-2': '#ccaa00', // #ccaa00
  'ternary-darken-1': '#e6c000', // #e6c000
  ternary: '#FFD500', // #FFD500
  'ternary-lighten-1': '#ffd91a', // #ffd91a
  'ternary-lighten-2': '#ffdd33', // #ffdd33
  'ternary-lighten-3': '#ffe24d', // #ffe24d
  'ternary-lighten-4': '#ffe666', // #ffe666
  // Red; 4th color
  'quaternary-darken-4': '#7d060a', // #7d060a
  'quaternary-darken-3': '#92070b', // #92070b
  'quaternary-darken-2': '#a7080d', // #a7080d
  'quaternary-darken-1': '#bc090e', // #bc090e
  quaternary: '#B00020',
  'quaternary-lighten-1': '#d62328', // #d62328
  'quaternary-lighten-2': '#da3b40', // #da3b40
  'quaternary-lighten-3': '#df5458', // #df5458
  'quaternary-lighten-4': '#e36c70', // #e36c70,
}

const energievolutieTheme = {
  dark: false,
  colors: {
    surface: '#F5F5F5',
    background: '#FFFFFF',
    highlight: '#f4f9e9',
    'surface-hover': '#fafafa',
    'chip': '#EEEEEE',
    'primary--text': '#FFFFFF',
    'gradient-1': '#f3ffd9',
    'gradient-2': '#fefffc',
    ...colors
  }
}

const energievolutieDarkTheme = {
  dark: true,
  colors: {
    highlight: '#212121',
    'surface-hover': '#292929',
    'chip': '#101010',
    'gradient-1': '#292929',
    'gradient-2': '#101010',
    ...colors
  },
};

export default createVuetify({
  locale: {
    // Sets the locale to Dutch, so that date pickers are automatically translated.
    locale: 'nl',
    messages: { nl },
  },
  aliases: {
    SearchBar: components.VTextField,
    ConfigurationSelect: components.VSelect,
    ConfigurationTextField: components.VTextField,
    MarkerButton: components.VBtn
  },
  defaults: {
    VBtn: {
      variant: "flat"
    },
    VCard: {
      variant: "flat"
    },
    SearchBar: {
      clearable: true,
      placeholder: "Zoeken",
      flat: true,
      variant: "solo-filled",
      density: "compact",
      glow: true,
      rounded: true,
      prependInnerIcon: "mdi-magnify", 
      iconColor: "green",
    },
    ConfigurationTextField: {
      variant: "underlined",
      color: "primary"

    },
    FormOverlay: {
      VTextField: {
        variant: "underlined",
        color: "primary"
      },
      VSelect: {
        variant: "outlined",
        color: "primary",
        bgColor: "background",
        baseColor: "primary",
        density: "comfortable",
        required: true,
        itemTitle: "display",
        itemValue: "id"
      }
    },
    // This should be phased out eventually by the FormOverlay nested definition.
    ConfigurationSelect: {
      required: true,
      variant: "outlined",
      color: "primary",
      bgColor: "background",
      baseColor: "primary-darken-4",
      density: "comfortable",
      itemTitle: "display",
      itemValue: "id"
    },
    VListItem: {
      exact: true
    },
    MarkerButton: {
      minHeight: "32",
      maxHeight: "32",
      variant: "flat",
      size: "small",
      slim: true
    },
    VDateInput: {
      variant: "outlined",
      color: "primary",
      bgColor: "background",
      baseColor: "primary-darken-4",
      density: "comfortable",
    }
  },
  theme: {
    // defaultTheme: 'energievolutieTheme',
    defaultTheme: 'system',
    themes: {
      light: energievolutieTheme,
      dark: energievolutieDarkTheme
    }
  },
  components,
  directives
})
